import React, { useEffect } from "react";
import TopMenu from "../TopMenu";
import EmbeddingToolInfo from "../../utils/EmbeddingToolInfo";
import SETTINGS from "../../globals";
import { useNavigate } from "react-router-dom";
import logo from "../resources/images/ChemiNova_logo.png";
import { useAuth } from "../../contexts/AuthContext";
import AppSections from "../../utils/AppSections";

export default function SignInSSO({ onAuthenticated }: any) {
  const navigate = useNavigate();
  const authManager = useAuth();

  useEffect(() => {
    if (authManager.getToken()) {
      navigate(SETTINGS.get_path({ section: AppSections.CHELEMENTS }));
    } else {
      authManager.launchSSOAuthenticationChallenge();
    }
  }, []);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    authManager.launchSSOAuthenticationChallenge();
  };

  return (
    <div>
      {EmbeddingToolInfo.isChemiAnalysis() && <TopMenu />}
      <section className="bg-gray-50 dark:bg-gray-900">
        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
          <img src={logo} className="h-12" alt="" />
          <div className="w-full bg-white rounded-lg shadow dark:border sm:max-w-md xl:p-0 mt-10">
            <div className="p-6 space-y-4 md:space-y-6 sm:p-8 text-center">
              <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 mb-16">
                Sign in to your account
              </h1>
              <form
                onSubmit={handleSubmit}
                className="space-y-4 md:space-y-6"
                action="#"
              >
                <button
                  type="submit"
                  className="w-full text-white bg-slate-500 hover:bg-slate-600 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                >
                  Sign in
                </button>
                <p className="text-sm font-light text-gray-500">
                  Don’t have an account yet?{" "}
                  <a
                    href="javascript:null"
                    className="font-medium text-primary-600 hover:underline"
                    onClick={() => navigate("/signup")}
                  >
                    Sign up
                  </a>
                </p>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
